var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"x-markdown-viewer-wrapper"},[_c('div',{staticClass:"x-markdown-viewer",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }